export default function(arrFeatures, map, padding) {
//	var pan = ol.animation.pan({duration: 500, source: map.getView().getCenter()})
//	var zoom = ol.animation.zoom({duration: 500, resolution: map.getView().getResolution()})
//	map.beforeRender(pan, zoom);
	
	var view = map.getView();
	var zoom = 14;
	if(map.getView().getZoom() > 14) {
		zoom = map.getView().getZoom();
	}
	const duration = 500;
	
	const featureToFit = arrFeatures[0].getGeometry();

	view.fit(featureToFit, {padding: padding, maxZoom: zoom, duration: duration});
	
	if(typeof callbackFunc != 'undefined')
		callbackFunc(feature);
}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/map/centerOnFeatures.js